// src/context/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('adminRole');
    if (token && (role === 'admin' || role === 'seo')) {
      setUser({ token, role });
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Login failed');
      if (data.role !== 'admin' && data.role !== 'seo') {
        throw new Error('Access denied: staff accounts only');
      }
      localStorage.setItem('token', data.token);
      localStorage.setItem('adminRole', data.role);
      setUser({ token: data.token, role: data.role });
      toast.success('Logged in successfully!');
      return data.role; // 'admin' | 'seo' — lets the caller route appropriately
    } catch (err) {
      toast.error(err.message || 'Login failed');
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('adminRole');
    setUser(null);
    toast.success('Logged out');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;